import { Company, Country, NameIdModel, Product, Region, Terminal } from '@ct/model';
import { createAction, props } from '@ngrx/store';

export const LoadProducts = createAction('[Static] Load Products');

export const LoadProductsSuccess = createAction('[Static] Load Products Success', props<{ products: Product[] }>());

export const LoadCountries = createAction('[Static] Load Countries');

export const LoadCountriesSuccess = createAction('[Static] Load Countries Success', props<{ countries: Country[] }>());

export const LoadCompanies = createAction('[Static] Load Companies');

export const LoadCompaniesSuccess = createAction('[Static] Load Companies Success', props<{ companies: Company[] }>());

export const LoadTerminals = createAction('[Static] Load Terminals');

export const LoadTerminalsSuccess = createAction('[Static] Load Terminals Success', props<{ terminals: Terminal[] }>());

export const LoadRegions = createAction('[Static] Load Regions');

export const LoadRegionsSuccess = createAction('[Static] Load Regions Success', props<{ regions: Region[] }>());

export const LoadVesselTypesSuccess = createAction(
  '[Static] Load vessel types Success',
  props<{ vesselTypes: Map<string, NameIdModel> }>()
);

export const LoadVessels = createAction('[Static] Load Vessels');

export const LoadVesselsSuccess = createAction('[Static] Load Vessels Success', props<{ vessels: Array<string> }>());
